import { useAuth0 } from '@auth0/auth0-react';
import type { AuthUser } from '@/types';

export function useAuth() {
  const { user, isAuthenticated, isLoading, loginWithRedirect, logout, getAccessTokenSilently } =
    useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return {
    user: user as AuthUser | undefined,
    isAuthenticated,
    isLoading,
    login: loginWithRedirect,
    logout: handleLogout,
    getAccessToken: getAccessTokenSilently,
  };
}
